export default __webpack_public_path__ + "static/media/cork-flooring_min.dcda222e.png";